import React from "react";
import HeroSection from "./Hero-section";
import AnimatedBackground from './About-section';
import ProductsSection from './Products-section';
import ContactSection from './Contact-me-section';

function ProfilePage() {
    const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <>
    <HeroSection onNavigate={scrollToSection} />
          <AnimatedBackground />
      <ProductsSection />
      <ContactSection />
      </>
  );
}

export default ProfilePage;